import React, { useEffect, useMemo, useState } from "react";
import { Image, Layout, Menu } from "antd";
import styles from "./Home.module.less";
// import CarinaLogo from "../resources/img/carina-logo.png";
// import CarinaLogoWhite from "../resources/img/salesta_white_ version .png";
import ClientRouter, { CLIENT_ROUTES } from "./ClientRouter";

import {
  FileTextOutlined,
  HomeFilled,
  LockFilled,
  LockOutlined,
  PoweroffOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import { useAuth } from "../components/hooks/useAuth";
import { GLOBAL_ROUTES } from "../Router";
import { useGlobalState } from "../components/hooks/useGlobalState";
import { INITIAL_AUTH } from "../components/providers/AuthProvider";
import { INITIAL_GLOBAL } from "../components/providers/GlobalProvider";
import { useRefreshToken } from "../components/hooks/useRefreshToken";
import { useGetSettings } from "../components/hooks/useGetSettings";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFileLines,
  faPowerOff,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import MobileMenu from "./MobileMenu";
import IssueModal from "../components/IssueModal";
import { Footer } from "antd/lib/layout/layout";
import { isKougenClient } from "../utils/tenantCheck";
import { useHealth } from "../components/hooks/useHealth";
import { useCheckDuplicateEmail } from "../components/hooks/useCheckDuplicateEmail";
import Loading from "../components/Loading";

const { Sider } = Layout;

function Home() {
  const { healthCheckFailed, healthCheckStatus } = useHealth();
  const { data: hasDuplicateEmail, status: duplicateEmailCheckStatus } =
    useCheckDuplicateEmail();

  useEffect(() => {
    console.log("HAS DUPLICATE EMAIL: ", hasDuplicateEmail);
  }, [hasDuplicateEmail]);

  // const { globalState } = useGlobalState();
  // const { auth } = useAuth();
  // const companyName = globalState.settings.companyName.value;
  // const {user: userVO, tenantId} = auth;
  // console.log(userVO);
  // console.log(tenantId);

  const { auth, setAuth, isLoggedIn } = useAuth();
  const { user } = auth;
  const { globalState, setGlobalState } = useGlobalState();
  const history = useHistory();

  const tenantId = useMemo(() => {
    return auth.tenantId;
  }, [auth]);

  if (tenantId) {
    // console.log("change favicon");
    let link: any = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = `/${tenantId}-favicon.ico`;

    // if you want to change application name uncomment this
    // document.getElementById("title")!.innerHTML = "app name";

    // const favicon: any = document.getElementById("favicon");
    // favicon.type = "application/json";
    // favicon.href = "../../public/wa-favicon.ico";
  }

  // Refresh token
  useRefreshToken();

  // Settings
  useGetSettings();

  const [currentMenuKey, setCurrentMenuKey] = useState<MenuKey>("home");

  const menuItems: Record<Exclude<MenuKey, "logout">, MenuItem> & {
    logout: Omit<MenuItem, "path">;
  } = {
    home: {
      label: "ホーム",
      icon: <HomeFilled />,
      path: GLOBAL_ROUTES.clientHome.path,
    },
    information: {
      label: "ユーザー情報",
      icon: <FontAwesomeIcon icon={faUser as IconProp} />,
      path: GLOBAL_ROUTES.clientHome.path + CLIENT_ROUTES.information.path,
    },
    manual: {
      label: "マニュアル",
      icon: <FontAwesomeIcon icon={faFileLines as IconProp} />,
      path: GLOBAL_ROUTES.clientHome.path + CLIENT_ROUTES.manual.path,
    },
    "change-password": {
      label: "パスワード変更",
      icon: <LockFilled />,
      path: GLOBAL_ROUTES.clientHome.path + CLIENT_ROUTES.changePassword.path,
    },
    logout: {
      label: "ログアウト",
      icon: <FontAwesomeIcon icon={faPowerOff as IconProp} />,
    },
  };

  const filteredMenuItems = useMemo(() => {
    if (hasDuplicateEmail) {
      return Object.fromEntries(
        Object.entries(menuItems).filter(([key]) => key === "logout")
      );
    } else {
      return menuItems;
    }
  }, [hasDuplicateEmail]);

  const clientLogo = useMemo(
    () =>
      tenantId === "wa1920" ? `/${tenantId}-logo.png` : "/carina-logo.png",
    [tenantId]
  );

  useEffect(() => {
    if (
      healthCheckFailed ||
      !isLoggedIn() ||
      !auth.authorities.includes("app")
    ) {
      history.push(GLOBAL_ROUTES.clientLogin.path);
    } else if (hasDuplicateEmail) {
      // check if current route doesn't contain either CLIENT_ROUTES.changeEmail.path or CLIENT_ROUTES.emailOtp.path
      if (
        !history.location.pathname.includes(CLIENT_ROUTES.changeEmail.path) &&
        !history.location.pathname.includes(CLIENT_ROUTES.emailOtp.path)
      ) {
        history.push(
          GLOBAL_ROUTES.clientHome.path + CLIENT_ROUTES.changeEmail.path
        );
      }
    } else {
      history.push(GLOBAL_ROUTES.clientHome.path + CLIENT_ROUTES.payment.path);
    }
  }, [healthCheckFailed, hasDuplicateEmail]);

  useEffect(() => {
    if (hasDuplicateEmail) {
      // check if current route doesn't contain either CLIENT_ROUTES.changeEmail.path or CLIENT_ROUTES.emailOtp.path
      if (
        !history.location.pathname.includes(CLIENT_ROUTES.changeEmail.path) &&
        !history.location.pathname.includes(CLIENT_ROUTES.emailOtp.path)
      ) {
        history.push(
          GLOBAL_ROUTES.clientHome.path + CLIENT_ROUTES.changeEmail.path
        );
      }
    }
  });

  const handleMenuClick = (key: MenuKey) => {
    if (key === "logout") {
      setGlobalState(INITIAL_GLOBAL);
      setAuth(INITIAL_AUTH);
      history.push(`${GLOBAL_ROUTES.clientLogin.path}?tenant=${tenantId}`);
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      history.push(filteredMenuItems[key].path);
      setCurrentMenuKey(key);
    }
  };

  // useEffect(() => {
  //   const hideEmailIssueModal = localStorage.getItem(
  //     `hideEmailIssueModal_${tenantId}_${user.userId}`
  //   );
  //   console.log(`hideEmailIssueModal_${tenantId}_${user.userId}`);
  //   console.log(`emailIssueModalSettings: ${hideEmailIssueModal}`);
  //   console.log("tenant:", tenantId);
  //   console.log("userId:", user.userId);
  //   const showPopup =
  //     hideEmailIssueModal == undefined || hideEmailIssueModal == "false"
  //       ? true
  //       : false;
  //   console.log(`showPopup: ${showPopup}`);
  //   if (showPopup) {
  //     setVisible(true);
  //   }
  // }, []);

  const showEmailIssueModal = () => {
    const hideEmailIssueModal = localStorage.getItem(
      `hideEmailIssueModal_${tenantId}_${user.userId}`
    );
    // console.log(`hideEmailIssueModal_${tenantId}_${user.userId}`);
    // console.log(`emailIssueModalSettings: ${hideEmailIssueModal}`);
    // console.log("tenant:", tenantId);
    // console.log("userId:", user.userId);
    return hideEmailIssueModal == undefined || hideEmailIssueModal == "false"
      ? true
      : false;
  };
  const showKougenIssueModal = () => {
    const hideKougenIssueModal = localStorage.getItem(
      `hideKougenIssueModal_${tenantId}_${user.userId}_fixed`
    );
    return isKougenClient({ tenantId, user: "client" }) &&
      (hideKougenIssueModal == undefined || hideKougenIssueModal == "false")
      ? true
      : false;
  };

  const [emailIssueModalVisible, setEmailIssueModalVisible] = useState({
    showModal: showEmailIssueModal(),
    showCheckbox: true,
  });
  const [kougenIssueModalVisible, setKougenIssueModalVisible] = useState({
    showModal: showKougenIssueModal(),
    showCheckbox: true,
  });

  // const menu = (
  //   <Menu>
  //     <Menu.Item key="1">2020</Menu.Item>
  //     <Menu.Item key="2">2019</Menu.Item>
  //     <Menu.Item key="3">2018</Menu.Item>
  //   </Menu>
  // );

  // toggle sidebar
  const [toggleSidebar, setOnToggleSidebar] = useState(false);
  const onToggleSidebar = () => {
    setOnToggleSidebar((prevState) => !prevState);
  };
  if (
    healthCheckStatus === "loading" ||
    duplicateEmailCheckStatus === "loading"
  ) {
    return (
      <Layout style={{ height: "100vh" }}>
        <Loading size="large" />
      </Layout>
    );
  }
  return (
    <>
      <Layout style={{ minHeight: "100vh" }}>
        <MobileMenu
          onKougenToggle={(visible: boolean) =>
            setKougenIssueModalVisible({
              showModal: visible,
              showCheckbox: false,
            })
          }
          openSidebar={onToggleSidebar}
          toggleSidebar={toggleSidebar}
        />
        <div
          className={
            toggleSidebar ? styles.mobile_display_open : styles.mobile_display
          }
        >
          <div className={styles.siderBody} onClick={onToggleSidebar}>
            <div className={styles.siderLogo}>
              <Image
                // src={CarinaLogoWhite}
                src={clientLogo}
                // width={160}
                // height={27.95}
                preview={false}
              />
              <p className={styles.mobile_logo_after}>
                お支払い通知書 <br />
                ユーザーマイページ
              </p>
            </div>
            <Menu
              style={{ marginTop: "30px", borderRight: "none !important" }}
              selectedKeys={[currentMenuKey]}
              onClick={(e) => handleMenuClick(e.key as MenuKey)}
              mode="inline"
            >
              {Object.entries(filteredMenuItems).map(([key, menuItem]) => (
                <Menu.Item key={key as MenuKey} icon={menuItem.icon}>
                  {menuItem.label}
                </Menu.Item>
              ))}
            </Menu>
          </div>
        </div>
        <div
          style={{ position: "fixed", height: "100%" }}
          className={styles.display}
        >
          <Sider className={styles.siderBody}>
            <div className={styles.siderLogo}>
              <Image
                // src={CarinaLogo}
                src={clientLogo}
                // width={160}
                // height={27.95}
                preview={false}
              />
              <p style={{ textAlign: "center", color: "#007AFF" }}>
                お支払い通知書 <br />
                ユーザーマイページ
              </p>
            </div>
            <Menu
              style={{ marginTop: "30px", borderRight: "none !important" }}
              selectedKeys={[currentMenuKey]}
              onClick={(e) => handleMenuClick(e.key as MenuKey)}
              mode="inline"
            >
              {Object.entries(filteredMenuItems).map(([key, menuItem]) => (
                <Menu.Item key={key as MenuKey} icon={menuItem.icon}>
                  {menuItem.label}
                </Menu.Item>
              ))}
            </Menu>
          </Sider>
        </div>
        <div>
          <ClientRouter />
        </div>
        <Footer>
          <div
            style={{
              bottom: "0px",
              right: "30px",
              position: "absolute",
              color: "red",
              fontSize: "0.8rem",
              display: "flex",
              gap: "1rem",
              // flexDirection: "column",
            }}
          >
            <div
              style={{ cursor: "pointer" }}
              onClick={() =>
                setEmailIssueModalVisible({
                  showModal: true,
                  showCheckbox: false,
                })
              }
            >
              メールが届かない場合は？
            </div>
          </div>
        </Footer>

        {/* REGULAR EMAIL ISSUE MODAL */}
        {tenantId && user.userId && (
          <IssueModal
            visible={emailIssueModalVisible.showModal}
            setVisible={(isVisible) =>
              setEmailIssueModalVisible({
                showModal: isVisible,
                showCheckbox: false,
              })
            }
            onClose={() =>
              setEmailIssueModalVisible({
                showModal: false,
                showCheckbox: false,
              })
            }
            showCheckbox={emailIssueModalVisible.showCheckbox}
            storageKey={`hideEmailIssueModal_${tenantId}_${user.userId}`}
            // tenantID={tenantId}
            // userID={user.userId}
          >
            <div style={{ textAlign: "center", fontSize: "18px" }}>
              <p>
                お支払通知書お届け時の通知メールが届かない場合は下記のご対応を
                <br />
                お願い致します。
              </p>
              <ul style={{ textAlign: "start", paddingLeft: "1rem" }}>
                <li>
                  迷惑メールフォルダに割り振られていないかをご確認ください。
                </li>
                <li>
                  「salesta.jp」をメールホワイトリストへ追加してください。
                </li>
              </ul>
            </div>
          </IssueModal>
        )}

        {/* KOUGEN ISSUE MODAL */}
        {tenantId &&
          user.userId &&
          isKougenClient({ tenantId, user: "client" }) && (
            <IssueModal
              visible={
                !emailIssueModalVisible.showModal &&
                kougenIssueModalVisible.showModal
              }
              setVisible={(isVisible) =>
                setKougenIssueModalVisible({
                  showModal: isVisible,
                  showCheckbox: false,
                })
              }
              onClose={() =>
                setKougenIssueModalVisible({
                  showModal: false,
                  showCheckbox: false,
                })
              }
              showCheckbox={kougenIssueModalVisible.showCheckbox}
              storageKey={`hideKougenIssueModal_${tenantId}_${user.userId}_fixed`}
              // tenantID={tenantId}
              // userID={user.userId}
            >
              <div style={{ textAlign: "center", fontSize: "18px" }}>
                <h2 style={{ fontSize: "2rem", marginBottom: "1rem" }}>
                  システム不具合に関するお知らせとお詫び【不具合修正が完了いたしました】
                </h2>
                <p style={{ textAlign: "left", fontSize: "1rem" }}>
                  平素は当社サービスをご利用頂き、誠にありがとうございます。
                  <br />
                  <br />
                  一部のお客様において本来のお支払通知書公開タイミングとは異なるタイミングでお支払通知書が公開されてしまう不具合について、システム修正の対応が完了いたしましたことをご報告させていただきます。
                  <br />
                  上記不具合の原因はシステムの不具合によるものでしたが、１月１３日時点で不具合の修正は完了しておりますことをご報告いたします。
                  <br />
                  <br />
                  今後このような事態を発⽣させることのないよう、再発防⽌に努めてまいります。
                  <br />
                  お客さまには多⼤なご迷惑をお掛けいたしましたこと、深くお詫び申し上げます。
                </p>
              </div>
            </IssueModal>
          )}
      </Layout>
    </>
  );
}

export default Home;

// Types
type MenuKey = "home" | "information" | "manual" | "change-password" | "logout";

type MenuItem = {
  label: string;
  icon: JSX.Element;
  path: string;
};
